import {
  type Control,
  type FieldPath,
  type FieldValues,
  useController,
} from 'react-hook-form'

export const useFormField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  control: Control<TFieldValues>,
  name: TName,
) => useController({ control, name }).field
